<template>
	<detail :is-view="false" />
</template>

<script>
	import Detail from './component/Detail'
	
	export default{
		name: 'AddTask',
		components: {Detail}
	}
</script>